import _ from 'lodash';
import { toLower, replace } from 'lodash';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PT from 'prop-types';
import {
  Icon,
  Table,
  Popup,
} from 'semantic-ui-react';
import TableControls from '../../components/TableControls';
import Link from '../../../lib/components/link';
import { DropdownOptionsType } from '../../../lib/proptypes/semantic';
import { selectControlsState } from '../../../store/reducers/tableControls';
import { positionToTitle } from '../../../lib/lookups';
import { gciPageView } from '../../../lib/analytics';
import { goToView } from '../../routes.global';
import {
  selectDepthChart,
  selectDepthChartState,
  DEPTHCHARTS_VIEW,
} from './module/depthcharts';
import { FormulaType } from '../../../lib/proptypes/formula';
import classes from './depthcharts.css';
import { PLAYER_VIEW } from '../Player/module/player';
import upsideIcon from '../../../assets/images/upside.png';
import downsideIcon from '../../../assets/images/downside.png';
import analysisIcon from '../../../assets/images/icon-analysis.png';
import analysisIconUpdated from '../../../assets/images/icon-analysis-updated.png';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { DFPSlotsProvider, AdSlot } from 'react-dfp';

function playerStatus(status) {
  switch(status) {
  case 'New to Team':
    status = 'N';
    break;
  case 'Rookie':
    status = 'R';
    break;
}
  return ((status != '') ? '(' + status + ')' : '');
}

const pageTitle = 'Fantasy football - NFL Depth Charts';

const mapStateToProps = state => {
  const { hasLoadedChart } = selectDepthChartState(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);
  const loggedIn = state.auth.loggedIn;
  const mediaType = state.browser.mediaType;
  return {
    // hasLoaded,
    hasLoadedChart,
    toolDescriptions,
    toolsLoaded,
    loggedIn,
    mediaType,
    collapsed: selectControlsState(state).collapsed,
    ...hasLoadedChart && {
      depthchart: selectDepthChart(state),
    },

    // ...hasLoaded && {
    //   depthcharts: selectDepthCharts(state),
    // },
  };
};
const actions = {
  goToView,
};
export class DepthCharts extends PureComponent {
  static propTypes = {
    depthchart: PT.object,
    depthcharts: PT.objectOf(PT.arrayOf(PT.shape({
      player_id: PT.number.isRequired,
      fname: PT.string.isRequired,
      lname: PT.string.isRequired,
      team: PT.string.isRequired,
      // fpts: PT.number.isRequired,
      bye: PT.number.isRequired,
      rank: PT.number.isRequired,
    }))),
    // hasLoaded: PT.bool.isRequired,
    collapsed: PT.bool.isRequired,
    goToView: PT.func.isRequired,
    gciPageView: PT.func.isRequired,
    // profiles: PT.arrayOf(FormulaType),
    toolsLoaded: PT.bool.isRequired,
    loggedIn: PT.bool.isRequired,
    mediaType: PT.string.isRequired,
  }

  static defaultProps = {
    depthcharts: null,
    depthchart: null,
    // profiles: [],
    loggedIn: false,
  }

  state = {
    touchResize: true,
    prevLogin: false,
    didFirst: false,
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
    this.setState({ didFirst: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.didFirst && this.state.prevLogin !== prevProps.loggedIn) {
      this.setState({ prevLogin: prevProps.loggedIn });
    }
  }

  componentWillUnmount() {
    // window.removeEventListener('resize', this.changeAuction.bind(this));
  }

  renderDepthTableHeader = () => {
    const positionsArray = [
      { abbr: "TM",
        name: "Team",
      },
      {
        abbr: "QB",
        name: "Quarterbacks",
      },
      {
        abbr: "RB",
        name: "Running Backs",
      },
      {
        abbr: "WR",
        name: "Wide Receivers",
      },
      {
        abbr: "TE",
        name: "Tight Ends",
      },
      {
        abbr: "K",
        name: "Kickers",
      },
    ]
    var tableHeader = positionsArray.map(function(position, i) {
        return ((i == 0) ? <Table.HeaderCell className={classes.headcol}>{position.name}</Table.HeaderCell> : <Table.HeaderCell>{position.name}</Table.HeaderCell>
          )
      })

    return(<Table.Header><Table.Row>{ tableHeader }</Table.Row></Table.Header>)
  }

  renderDepthTable = (depthchart) => {

    //loop through teams


    // console.log('depthchart.depth_chart["1"]["QB"][0]["fname"] ', depthchart.depth_chart["1"]["QB"]["players"][0]["fname"]);
    const depth_chart = depthchart.depth_chart;

    // probably a way to get this from api/DB, but i'm unsure how. #todo
    const teams = [
      { order:  1 ,id: '26', abbr: 'ARI', teamLink: 'arizona-cardinals'},
      { order:  2 ,id: '12', abbr: 'ATL', teamLink: 'atlanta-falcons'},
      { order:  3 ,id: '24', abbr: 'BAL', teamLink: 'baltimore-ravens'},
      { order:  4 ,id: '25', abbr: 'BUF', teamLink: 'buffalo-bills'},
      { order:  5 ,id: '15', abbr: 'CAR', teamLink: 'carolina-panthers'},
      { order:  6 ,id: '27', abbr: 'CHI', teamLink: 'chicago-bears'},
      { order:  7 ,id: '23', abbr: 'CIN', teamLink: 'cincinnati-bengals'},
      { order:  8 ,id: '29', abbr: 'CLE', teamLink: 'cleveland-browns'},
      { order:  9 ,id: '6',  abbr: 'DAL', teamLink: 'dallas-cowboys'},
      { order: 10 ,id: '8',  abbr: 'DEN', teamLink: 'denver-broncos'},
      { order: 11 ,id: '2',  abbr: 'DET', teamLink: 'detroit-lions'},
      { order: 12 ,id: '14', abbr: 'GB',  teamLink: 'green-bay-packers'},
      { order: 13 ,id: '11', abbr: 'HOU', teamLink: 'houston-texans'},
      { order: 14 ,id: '19', abbr: 'IND', teamLink: 'indianapolis-colts'},
      { order: 15 ,id: '13', abbr: 'JAC', teamLink: 'jacksonville-jaguars'},
      { order: 16 ,id: '31', abbr: 'KC',  teamLink: 'kansas-city-chiefs'},
      { order: 17 ,id: '10', abbr: 'LVR', teamLink: 'las-vegas-raiders'},
      { order: 18 ,id: '3',  abbr: 'LAC', teamLink: 'los-angeles-chargers'},
      { order: 19 ,id: '9',  abbr: 'LAR', teamLink: 'los-angeles-rams'},
      { order: 20 ,id: '7',  abbr: 'MIA', teamLink: 'miami-dolphins'},
      { order: 21 ,id: '16', abbr: 'MIN', teamLink: 'minnesota-vikings'},
      { order: 22 ,id: '1',  abbr: 'NE',  teamLink: 'new-england-patriots'},
      { order: 23 ,id: '5',  abbr: 'NO',  teamLink: 'new-orleans-saints'},
      { order: 24 ,id: '17', abbr: 'NYG', teamLink: 'new-york-giants'},
      { order: 25 ,id: '22', abbr: 'NYJ', teamLink: 'new-york-jets'},
      { order: 26 ,id: '28', abbr: 'PHI', teamLink: 'philadelphia-eagles'},
      { order: 27 ,id: '18', abbr: 'PIT', teamLink: 'pittsburgh-steelers'},
      { order: 28 ,id: '21', abbr: 'SEA', teamLink: 'seattle-seahawks'},
      { order: 29 ,id: '32', abbr: 'SF',  teamLink: 'san-francisco-49ers'},
      { order: 30 ,id: '20', abbr: 'TB',  teamLink: 'tampa-bay-buccaneers'},
      { order: 31 ,id: '30', abbr: 'TEN', teamLink: 'tennessee-titans'},
      { order: 32 ,id: '4',  abbr: 'WAS', teamLink: 'washington-football-team'}
    ]

    // should have this iterate through 5 times for the 5 positions, but couldn't get that working #todo
    var teamsList = teams.map(function(team) {
                    const imgRoot = 'https://www.gannett-cdn.com/media/SMG/sports_logos/nfl-whitebg/60/';
                    const teamLinkRoot = '/nfl-team/';
                    const washLogo = 'https://thehuddle.s3.amazonaws.com/images/WAS2.png';
                    var eligibility = '';
                    var experience = '';
                    var tableStripe = (team.order%2 == 0 ? 'even' : 'odd');
                    return ( <Table.Row className={tableStripe}>
                      <Table.Cell className={classes.teamCell, classes.headcol}><a href={teamLinkRoot + team.id + '/' + team.teamLink }>
                        {team.abbr == 'WAS' ? <img src={washLogo} width='35' /> :
                          <img src={imgRoot + (team.abbr == 'LVR' ? 'OAK' : team.abbr) + '.png'} width='35' />
                        }
                        <div>{team.abbr}</div>
                      </a></Table.Cell>
                      <Table.Cell className={classes.playerCell}>
                        {typeof depthchart.depth_chart[team.id]['QB'] !== 'undefined' && depthchart.depth_chart[team.id]['QB']['players'].map(function(player) {
                          eligibility = playerStatus(player['eligibility_suggestion']);
                          experience = playerStatus(player['experience']);
                          return (
                            (player.visible == 1) ? <div><a href={'/player/' + player.player_id + '/' + player['fname'].toLowerCase().replace(/\./g, '') + '-' + player['lname'].toLowerCase()}>{player['fname']} {player['lname']} <strong>{ experience } { eligibility }</strong></a></div> : ''
                            )
                        })}
                      </Table.Cell>
                      <Table.Cell className={classes.playerCell}>
                        {typeof depthchart.depth_chart[team.id]['RB'] !== 'undefined' && depthchart.depth_chart[team.id]['RB']['players'].map(function(player) {
                          eligibility = playerStatus(player['eligibility_suggestion']);
                          experience = playerStatus(player['experience']);
                          return (
                            (player.visible == 1) ? <div><a href={'/player/' + player.player_id + '/' + player['fname'].toLowerCase().replace(/\./g, '') + '-' + player['lname'].toLowerCase()}>{player['fname']} {player['lname']} <strong>{ experience } { eligibility }</strong></a></div> : ''
                            )
                        })}
                      </Table.Cell>
                       <Table.Cell className={classes.playerCell}>
                        {typeof depthchart.depth_chart[team.id]['WR'] !== 'undefined' && depthchart.depth_chart[team.id]['WR']['players'].map(function(player) {
                          eligibility = playerStatus(player['eligibility_suggestion']);
                          experience = playerStatus(player['experience']);
                          return (
                            (player.visible == 1) ? <div><a href={'/player/' + player.player_id + '/' + player['fname'].toLowerCase().replace(/\./g, '') + '-' + player['lname'].toLowerCase()}>{player['fname']} {player['lname']} <strong>{ experience } { eligibility }</strong></a></div> : ''
                            )
                        })}
                      </Table.Cell>
                      <Table.Cell className={classes.playerCell}>
                        {typeof depthchart.depth_chart[team.id]['TE'] !== 'undefined' && depthchart.depth_chart[team.id]['TE']['players'].map(function(player) {
                          eligibility = playerStatus(player['eligibility_suggestion']);
                          experience = playerStatus(player['experience']);
                          return (
                            (player.visible == 1) ? <div><a href={'/player/' + player.player_id + '/' + player['fname'].toLowerCase().replace(/\./g, '') + '-' + player['lname'].toLowerCase()}>{player['fname']} {player['lname']} <strong>{ experience } { eligibility }</strong></a></div> : ''
                            )
                        })}
                       </Table.Cell>
                       <Table.Cell className={classes.playerCell}>
                        {typeof depthchart.depth_chart[team.id]['PK'] !== 'undefined' && depthchart.depth_chart[team.id]['PK']['players'].map(function(player) {
                          eligibility = playerStatus(player['eligibility_suggestion']);
                          experience = playerStatus(player['experience']);
                          return (
                            (player.visible == 1) ? <div><a href={'/player/' + player.player_id + '/' + player['fname'].toLowerCase().replace(/\./g, '') + '-' + player['lname'].toLowerCase()}>{player['fname']} {player['lname']} <strong>{ experience } { eligibility }</strong></a></div> : ''
                            )
                        })}
                      </Table.Cell>
                    </Table.Row>
                      )
                  })

    return  <Table.Body>{ teamsList }</Table.Body>
  }

  render = () => {
    const {
      // hasLoaded,
      hasLoadedChart,
      toolDescriptions,
      toolsLoaded,
      mediaType,
    } = this.props;

    // Always returns false if there's no data for index 0
    // const hasData = !!(depthchart);

    // Updated it to loop through the depthcharts results until it finds at least one position w/data

    var { depthcharts, depthchart } = this.props;

    let clientWidth = null;

    const hasData = !!(depthchart && typeof window !== 'undefined');

    return (
      <div className={classes.wrapper}>
        <DFPSlotsProvider dfpNetworkId="7103">
          {(mediaType === 'mobile' ?
          <div style={{marginTop: '10px'}}>
          <center>
          <AdSlot
            adUnit="SMG_TheHuddle/300x250_1m/sports/fantasy/football.general"
            sizes={ [[300, 250], [320, 480], [320, 50], [300, 50]] }
          />
          </center></div> :
          <AdSlot
            adUnit="SMG_TheHuddle/728x90_flex/sports/fantasy/football.general"
            sizes={ [[970, 250], [728, 90], [970, 66]] }
          />)}
        </DFPSlotsProvider>
        <div style={{marginBottom: '10px'}}/>
        <div className={classes.pageTitle}>
              {pageTitle}
          <div className={classes.timestamp}>
             <span> Latest Update: </span> {depthchart.updated_at}
          </div>
        </div>
        <br/>
        <div className={classes.pageTools}>
          <ToolDescription
                descr={(toolDescriptions && toolDescriptions.tool_descriptions.depth_charts) ? toolDescriptions.tool_descriptions.depth_charts.text : ''}
              />
        </div>
        <div className={classes.legend}><span><strong>Legend:&nbsp;&nbsp;&nbsp;(N)</strong> = New to Team</span> <span><strong> (R)</strong> = Rookie</span> <span><strong> (IR)</strong> = Injured Reserve</span> <span><strong> (PUP)</strong> =  Physically Unable to Perform</span> <span><strong> (IR-R)</strong> = Injured Reserve w/ opportunity to return</span> <span><strong> (SUS)</strong> = Suspended</span></div>
        { /* <TableControls /> */ }

        <div className={classes.chartWrapper}>
          <Table ui celled striped table dataTable>
            { this.renderDepthTableHeader() }
            { depthchart && this.renderDepthTable(depthchart) }
          </Table>
        </div>

        {(hasLoadedChart && !hasData) && <h3>No data currently available for Depth Charts.</h3>}

      </div>
    );
  }
}
export default connect(mapStateToProps, actions)(DepthCharts);



// WEBPACK FOOTER //
// ./src/app/views/DepthCharts/DepthCharts.js